import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { id: "Essays" }
const _hoisted_3 = { class: "text-center pt-16" }
const _hoisted_4 = { id: "Contact" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { id: "TechnologyStack" }
const _hoisted_7 = { class: "text-center pb-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_SkillLogo = _resolveComponent("SkillLogo")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mt-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "6",
            "offset-lg": "3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_router_link, {
                  to: { name: 'startups' },
                  class: "text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("h1", { class: "text-center font-weight-bold" }, [
                      _createTextVNode(" Building "),
                      _createElementVNode("br"),
                      _createElementVNode("u", null, "Startups and Enterprise products"),
                      _createTextVNode(),
                      _createElementVNode("br"),
                      _createTextVNode(" that define our present and future. ")
                    ], -1),
                    _createElementVNode("h4", { class: "text-center font-weight-bold text-uppercase" }, " 🌟 For the past 15 years 🚀 ", -1)
                  ])),
                  _: 1,
                  __: [0]
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-16" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "10",
            "offset-lg": "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: { name: 'startups' },
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: "/img/essay/andromeda-technology-overview.png",
                    contain: ""
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            lg: "6",
            "offset-lg": "3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_2, [
                _createVNode(_component_v_card, { class: "mt-16" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      class: "white--text align-end",
                      height: "300",
                      cover: "",
                      src: "/img/essay/andromeda-wallpaper-1.png"
                    }),
                    _createVNode(_component_v_alert, { color: "rgba(0,0,0,0)" }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createElementVNode("p", null, " Andromeda.Technology partners with clients across Europe and globally, including: EU regions, London, Amsterdam, Berlin, Germany, France, and the UK, United States and international clients. ", -1),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("ol", null, [
                          _createElementVNode("li", null, " Individual specialists embedded into existing teams "),
                          _createElementVNode("li", null, " Full-stack teams dedicated as strategic technology partners "),
                          _createElementVNode("li", null, " End-to-end project development from initial concept to production ")
                        ], -1),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("p", null, " Our preferred engagement is building projects from the ground up, ensuring architecture, technology, and team alignment from day one. Contact us if you have interesting challenges — for complete project leadership, development and consultancy.", -1)
                      ])),
                      _: 1,
                      __: [1]
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          block: "",
                          href: "https://medium.com/andromeda-technology/andromeda-technology-full-spectrum-software-leadership-for-startups-and-enterprise-projects-dcc339cdb69e"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createElementVNode("h4", null, " Read the Medium essay ", -1)
                          ])),
                          _: 1,
                          __: [2]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_card, {
                    class: "mx-auto",
                    "max-width": "100%"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        class: "white--text align-end",
                        height: "300",
                        cover: "",
                        src: "/img/essay/self-aware-software-artisan.jpeg"
                      }),
                      _createVNode(_component_v_alert, { color: "rgba(0,0,0,0)" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createElementVNode("h3", null, " Self-Aware Software Artisan ", -1)
                            ])),
                            _: 1,
                            __: [3]
                          }),
                          _createVNode(_component_v_card_text, { class: "text-center" }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createElementVNode("p", null, " Powering individual's continual evolution and meaningful contribution to humanity through Software Development. ", -1)
                            ])),
                            _: 1,
                            __: [4]
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            block: "",
                            href: "https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("h4", null, " Read the Medium essay ", -1)
                            ])),
                            _: 1,
                            __: [5]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_v_row, { class: "mt-16" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              "offset-lg": "3",
              lg: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    href: "mailto:hi@andromeda.technology",
                    block: "",
                    color: "purple",
                    class: "mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "pr-4" }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-mail", -1)
                        ])),
                        _: 1,
                        __: [6]
                      }),
                      _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Contact us", -1))
                    ]),
                    _: 1,
                    __: [7]
                  }),
                  false
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        "x-large": "",
                        href: "http://eepurl.com/hFA-65",
                        block: "",
                        color: "purple",
                        class: "py-8 mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            large: "",
                            class: "mr-4"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("notifications", -1)
                            ])),
                            _: 1,
                            __: [8]
                          }),
                          _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Subscribe", -1))
                        ]),
                        _: 1,
                        __: [9]
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createVNode(_component_v_row, { class: "mb-16" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              "offset-lg": "3",
              lg: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_SkillLogo, {
                    name: "TypeScript",
                    src: "/img/technology/typescript.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "Solidity",
                    src: "/img/technology/solidity.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "NestJS",
                    src: "/img/technology/nestjs.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "Koa.js",
                    src: "/img/technology/koajs.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "Kafka",
                    src: "/img/technology/kafka.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "MongoDB",
                    src: "/img/technology/mongo.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "Elasticsearch",
                    src: "/img/technology/elasticsearch.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "GraphQL",
                    src: "/img/technology/graphql.png"
                  }),
                  _createVNode(_component_SkillLogo, {
                    name: "Vue.JS",
                    src: "/img/technology/vuejs.png"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}